var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 83.998,
    viewBox: "0 0 84 83.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_292_18",
    "data-name": "Component 292 \\u2013 18",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M40.5.5a40,40,0,1,1-40,40A40,40,0,0,1,40.5.5Z",
    transform: "translate(-0.5 -0.501)",
    fill: "none",
    stroke: "#121e59",
    strokeWidth: 4,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    d: "M65.9,67.179A16.9,16.9,0,0,0,54.044,51.053a22.271,22.271,0,0,1-27.339,0A16.9,16.9,0,0,0,14.853,67.179",
    transform: "translate(-0.374 -8.215)",
    fill: "none",
    stroke: "#121e59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120",
    "data-name": "Ellipse 120",
    cx: 13.644,
    cy: 13.644,
    r: 13.644,
    transform: "translate(26.356 11.588)",
    fill: "none",
    stroke: "#121e59",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    "data-name": "Path 1285",
    d: "M52.925,33.969a7.065,7.065,0,0,1-9.606-.09",
    transform: "translate(-8.17 -3.512)",
    fill: "none",
    stroke: "#121e59",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_121",
    "data-name": "Ellipse 121",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(43 21)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_122",
    "data-name": "Ellipse 122",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(33 21)",
    fill: "#121e59"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderUserIcon);
export default __webpack_public_path__ + "static/media/headerUserIcon.865b8c0cf4ab75a3d0634d0289a93014.svg";
export { ForwardRef as ReactComponent };